import styled from 'styled-components';

export const DividerContainer = styled.div`
  width: 100%;
  max-width: 26.625rem;
  border-bottom: 5px solid #878785;
  border-radius: 0.625rem;
`;
